import script from "./UserProfileView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileView.vue?vue&type=script&setup=true&lang=js"

import "./UserProfileView.vue?vue&type=style&index=0&id=1ec9a4d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ec9a4d1"]])

export default __exports__